import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivationEnd } from "@angular/router";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { TaxReturnService } from "../../../swaggerServices";
import { ConfigStateService } from "../config/config-state.service";
import { forkJoin, Subscription } from "rxjs";
import { UserInfoService } from "../user-info.service";
import { TenantConfigService } from "../../shared/services/tenant-config.service";
import { TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { TranslocoService} from "@jsverse/transloco";
import { environment } from '../../environments/environment';

@Component({
    selector: "app-settings",
    templateUrl: "./settings.component.html",
    styleUrls: ["./settings.component.scss"],
    providers: [
        {
            provide: TRANSLOCO_SCOPE,
            useValue: 'settings'
        }
    ],
    standalone: false
})
export class SettingsComponent implements OnInit, OnDestroy {
  hideSidebar: boolean = false;
  isSyncingCache: boolean;
  subscriptions: Subscription[] = [];
  uiConfig: TenantConfigService;
  taxIdVariable: string;
  taxReturnAlias: string;
  taxpayerAlias: string;
  yearLabel: string;
  taxReturnAliasPath: string;
  countryAlias: string;
  isProductionMode: boolean;
  isSmartFormsEnabled: boolean;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private taxReturnService: TaxReturnService,
    private config: ConfigStateService,
    public userInfo: UserInfoService,
    private translocoService: TranslocoService
  ) { this.isProductionMode = environment.production }

  // hide settings sidebar based on child route
  ngOnInit() {
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.taxReturnAlias = this.uiConfig.config.taxReturnAlias
        this.taxpayerAlias = this.uiConfig.config.taxpayerAlias
        this.taxReturnAliasPath = this.uiConfig.config.taxReturnAliasPath
        this.countryAlias = this.uiConfig.config.countryAlias
        this.yearLabel = this.uiConfig.config.yearLabel
        this.isSmartFormsEnabled=this.config.featureFlags.enableOneteamIntegration
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);
        this.translocoService.selectTranslate('tax-payer-alias').subscribe(value => this.taxpayerAlias = value);
        this.translocoService.selectTranslate('tax-return-alias').subscribe(value => this.taxReturnAlias = value);
        this.translocoService.selectTranslate('country-alias').subscribe(value => this.countryAlias = value);
      })
    );
    this.hideSidebar =
      this.activatedRoute.firstChild.data["value"].hideSettingsSidebar ||
      (this.activatedRoute.firstChild &&
        this.activatedRoute.firstChild.firstChild &&
        this.activatedRoute.firstChild.firstChild.data["value"].hideSettingsSidebar) ||
      (this.activatedRoute.firstChild &&
        this.activatedRoute.firstChild.firstChild &&
        this.activatedRoute.firstChild.firstChild.firstChild &&
        this.activatedRoute.firstChild.firstChild.firstChild.data["value"].hideSettingsSidebar);
    this.subscriptions.push(
      this.router.events.subscribe(event => {
        if (event instanceof ActivationEnd)
          this.hideSidebar =
            this.activatedRoute.firstChild.data["value"].hideSettingsSidebar ||
            (this.activatedRoute.firstChild &&
              this.activatedRoute.firstChild.firstChild &&
              this.activatedRoute.firstChild.firstChild.data["value"].hideSettingsSidebar) ||
            (this.activatedRoute.firstChild &&
              this.activatedRoute.firstChild.firstChild &&
              this.activatedRoute.firstChild.firstChild.firstChild &&
              this.activatedRoute.firstChild.firstChild.firstChild.data["value"].hideSettingsSidebar);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  syncCache() {
    this.isSyncingCache = true;
    this.subscriptions.push(
      forkJoin([
        this.taxReturnService.syncTaxReturnStructure(),
        this.taxReturnService.syncGlobalStructure(),
      ]).subscribe(() => {
        this.isSyncingCache = false;
      })
    );
  }
}
